import type { OverviewPatient } from '../../../services/patient';
import { LatestNotesCard } from './LatestNotesCard';
import { StatusActionCard } from './StatusActionCard';
import { TreatmentProgressCard } from './TreatmentProgressCard';
import { UpcomingAppointmentsCard } from './UpcomingAppointmentsCard';

interface OverviewTabProps {
    patient: OverviewPatient | null;
    patientId: string | null;
}

// Rows carry a 240px floor so this container scrolls instead of being clipped
// by the viewport-locked shell above it.
function OverviewTab({ patient, patientId }: OverviewTabProps) {
    return (
        <div className="h-full min-h-0 overflow-y-auto scrollbar-subtle flex flex-col p-5 gap-4">
            <StatusActionCard patient={patient} patientId={patientId} />

            <div className="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-2 gap-4 auto-rows-[minmax(240px,auto)] lg:grid-rows-[repeat(2,minmax(240px,1fr))]">
                <div className="min-h-[380px] lg:min-h-0 lg:row-span-2">
                    <TreatmentProgressCard patient={patient} patientId={patientId} />
                </div>
                <LatestNotesCard patientId={patientId} />
                <UpcomingAppointmentsCard patientId={patientId} />
            </div>
        </div>
    );
}

export { OverviewTab };
